import * as tslib_1 from "tslib";
import { AfterViewInit, ErrorHandler, OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogConfig, MatDialog, MatSnackBar } from '@angular/material';
import { BusinessService } from '../../business/models/business-service.model';
import { EditFeeComponent } from '../../business/edit-fee/edit-fee.component';
import { DeleteFeeComponent } from '../../business/delete-fee/delete-fee.component';
import { EditToggleService } from '../services/edit-toggle.service';
import { Business } from '../../business/models/business.model';
import { FormControl } from '@angular/forms';
import { AirportService } from '../../airport/airport.service';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { State } from '../state-view/state.model';
var BusinessFeesComponent = /** @class */ (function () {
    function BusinessFeesComponent(_toggleService, _editFeeDialog, _deleteFeeDialog, snackBar, _auth, _userService, _airportService, _errorHandler) {
        this._toggleService = _toggleService;
        this._editFeeDialog = _editFeeDialog;
        this._deleteFeeDialog = _deleteFeeDialog;
        this.snackBar = snackBar;
        this._auth = _auth;
        this._userService = _userService;
        this._airportService = _airportService;
        this._errorHandler = _errorHandler;
        this.query = '';
        this.formatFeeBasis = BusinessService.formatFeeBasis;
        this.displayedColumns = ['description', 'fee', 'feeBasis', 'aircraftType', 'serviceNote'];
        this.aircraftFilter = new FormControl();
        this.aircraftTypeCheckbox = new FormControl();
        this.filteredValues = {
            description: '', fee: '',
            feeBasis: '', serviceNote: '', aircraftType: ''
        };
        this.authenticated = false;
        this.state = State.Empty;
    }
    BusinessFeesComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Update state based on latest event in authStream, and subscribe to any future
        // changes in authentication state.
        this._onAuthEvent(this._auth.authStream.getValue());
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
        // Update state based on latest available userInfo, and subscribe to any future
        // changes to userInfo.
        this._userInfo = this._userService.userInfo.getValue();
        if (this._userInfo && this._userInfo.aircraftType) {
            this.aircraftFilter.setValue(this._userInfo.aircraftType);
        }
        this._userService.userInfo.subscribe(function (u) {
            // Update userInfo
            _this._userInfo = u;
            // Set state to loaded
            _this.state = State.Content;
            if (_this._userInfo && _this._userInfo.aircraftType) {
                _this.aircraftFilter.setValue(_this._userInfo.aircraftType);
            }
        });
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
            if (_this.editModeSet) {
                _this.aircraftFilter.setValue('All Aircraft');
            }
        });
        this.setDataSource();
        /* set filter here for saved aircraft type preference */
        this.dataSource.filter = JSON.stringify(this.filteredValues);
        this.aircraftFilter.valueChanges.subscribe(function (aircraftFilterValue) {
            _this.filteredValues['aircraftType'] = aircraftFilterValue;
            _this.dataSource.filter = JSON.stringify(_this.filteredValues);
            if (_this.aircraftTypeCheckbox.value) {
                // save change if checkbox checked
                _this.saveAircraftType(_this.aircraftFilter.value);
            }
        });
    };
    BusinessFeesComponent.prototype.saveAircraftType = function (aircraftType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._userService.setAircraftType(aircraftType)];
                    case 1:
                        _a.sent();
                        this.snackBar.open(aircraftType + " was set as your default aircraft type.", 'Dismiss', {
                            duration: 2000
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.snackBar.open('An error occurred updating your default aircraft type. Please try again later.', 'Dismiss', {
                            duration: 6000
                        });
                        this._errorHandler.handleError(e_1);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BusinessFeesComponent.prototype._onAuthEvent = function (e) {
        this.authenticated = this._auth.authenticated;
        if (this.authenticated && !this._auth.endUser) {
            // userInfo is not available when not authenticated as an end user, so set favorite state to loaded now.
            this.state = State.Content;
        }
    };
    BusinessFeesComponent.prototype.formatFee = function (fee) {
        return Number.isInteger(fee) ? '1.0-0' : '1.2-2';
    };
    BusinessFeesComponent.prototype.setDataSource = function () {
        var fees = this.sortedFees;
        this.dataSource = new MatTableDataSource(fees);
    };
    BusinessFeesComponent.prototype.setDataSourceFeatures = function () {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.customFilterPredicate();
        /* this.dataSource.filterPredicate = (data: BusinessService, filter: string) =>
          (data.description && data.description.toLowerCase().trim().indexOf(filter) !== -1)
          || (data.feeBasis && BusinessService.formatFeeBasis(data.feeBasis).toLowerCase().trim().indexOf(filter) !== -1)
          || (data.serviceNote && data.serviceNote.toLowerCase().trim().indexOf(filter) !== -1)
          || (data.fee && (String('$' + data.fee.toFixed(2)).toLowerCase().trim().indexOf(filter) !== -1)); */
    };
    /**
     * Set the paginator, sort, and filterPredicate after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    BusinessFeesComponent.prototype.ngAfterViewInit = function () {
        this.setDataSourceFeatures();
        if (this._userInfo && this._userInfo.aircraftType) {
            this.aircraftFilter.setValue(this._userInfo.aircraftType);
        }
    };
    BusinessFeesComponent.prototype.applyFilter = function (filter) {
        this.query = (filter || '').trim().toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filteredValues);
    };
    BusinessFeesComponent.prototype.customFilterPredicate = function () {
        var _this = this;
        var myFilterPredicate = function (data, filter) {
            var globalMatch = !_this.query;
            if (_this.query) {
                // search all text fields
                globalMatch = // data.name.toString().trim().toLowerCase().indexOf(this.globalFilter.toLowerCase()) !== -1;
                    (data.description && data.description.toLowerCase().trim().indexOf(_this.query) !== -1)
                        || (data.feeBasis && BusinessService.formatFeeBasis(data.feeBasis).toLowerCase().trim().indexOf(_this.query) !== -1)
                        || (data.serviceNote && data.serviceNote.toLowerCase().trim().indexOf(_this.query) !== -1)
                        || (data.fee && (String('$' + data.fee.toFixed(2)).toLowerCase().trim().indexOf(_this.query) !== -1));
            }
            if (!globalMatch) {
                return;
            }
            var searchString = JSON.parse(filter);
            if (searchString.aircraftType) {
                // if an aircraft type has been chosen in the dropdown
                if (searchString.aircraftType === 'All Aircraft') {
                    // if the dropdown is 'All Aircraft' return everything including nulls
                    return true;
                }
                else {
                    // when a specific aircraft type is selected, return nulls, 'All Aircraft', 'Unknown', and the selected type
                    return (!data.aircraftType
                        || data.aircraftType.toString().trim().toLowerCase().indexOf('all aircraft') !== -1
                        || data.aircraftType.toString().trim().toLowerCase().indexOf('unknown') !== -1
                        || data.aircraftType.toString().trim().toLowerCase().indexOf(searchString.aircraftType.toLowerCase()) !== -1);
                }
            }
            else {
                // no aircraft type chosen, filter everything until a type is chosen
                return;
            }
        };
        return myFilterPredicate;
    };
    Object.defineProperty(BusinessFeesComponent.prototype, "sortedFees", {
        get: function () {
            return this.fees
                .sort(function (a, b) {
                if (a.description < b.description) {
                    return -1;
                }
                if (a.description > b.description) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    BusinessFeesComponent.prototype.checkBoxDisabled = function () {
        if (!this._auth.authenticated || !this._auth.endUser) {
            return true;
        }
        if (this.aircraftFilter && this.aircraftFilter.value) {
            return false;
        }
        return true;
    };
    BusinessFeesComponent.prototype.filterDisabled = function () {
        if (this.editModeSet) {
            return true;
        }
        return false;
    };
    BusinessFeesComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                try {
                    result = void 0;
                    if (event.checked && this.aircraftFilter && this.aircraftFilter.value) {
                        this.saveAircraftType(this.aircraftFilter.value);
                    }
                }
                catch (e) {
                    this.snackBar.open('Error saving aircraft type preference, please try again later', 'Error', {
                        duration: 6000
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    BusinessFeesComponent.prototype.reloadBusiness = function (businessId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(businessId)];
                    case 1:
                        _a.business = _b.sent();
                        this.fees = this.business.services;
                        this.dataSource = new MatTableDataSource(this.sortedFees);
                        this.setDataSourceFeatures();
                        this.aircraftFilter.setValue('All Aircraft');
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessFeesComponent.prototype.openEditFeeDialog = function (row) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            busID: this.business.id,
            id: null,
            isNew: false
        };
        row == null ? dialogConfig.data.isNew = true : dialogConfig.data.fee = row;
        dialogConfig.data['busID'] = this.business.id;
        dialogConfig.width = '60%';
        var dialogRef = this._editFeeDialog.open(EditFeeComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.reloadBusiness(_this.business.id.toString());
                if (isUpdated.isNew) {
                    _this.snackBar.open('Fee', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this.snackBar.open('Fee', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    BusinessFeesComponent.prototype.deleteFee = function (row) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            businessID: this.business.id,
            serviceId: row.serviceId
        };
        var dialogRef = this._deleteFeeDialog.open(DeleteFeeComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.reloadBusiness(_this.business.id.toString());
                _this.snackBar.open('Fee', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    Object.defineProperty(BusinessFeesComponent.prototype, "hasContent", {
        get: function () {
            return typeof this.fees !== 'undefined' && this.fees !== null && this.fees.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    return BusinessFeesComponent;
}());
export { BusinessFeesComponent };
